// extracted by mini-css-extract-plugin
export var avatar = "_qb-3";
export var avatarContainer = "_qb-2";
export var avatarSpacer = "_qb-5";
export var avatarSpacerContainer = "_qb-4";
export var avatarStackContainer = "_qb-1";
export var bubble = "_qb-0";
export var remainderBubble = "_qb-6";